module.exports = __webpack_public_path__ + "static/media/Desiree@2x.04633fd0.jpg";